import React from 'react';
import { Button, ButtonGroup } from 'design-system';
import { View } from 'react-native';
import RollingBudgetContent from './RollingBudgetContent';
const strings = {
    buttonEnable: `Got it, let’s roll over`,
    buttonDisable: `Got it, let’s stop`,
};
const RollingBudgetModalContent = ({ onPressContinue, onPressCancel, isEnabling, }) => (<View>
    <RollingBudgetContent showDescription isEnabling={isEnabling}/>
    <ButtonGroup margins={false}>
      <Button brandReversed title="Cancel" onPress={onPressCancel}/>
      <Button brand title={isEnabling ? strings.buttonEnable : strings.buttonDisable} onPress={onPressContinue}/>
    </ButtonGroup>
  </View>);
export default RollingBudgetModalContent;
